// @flow
import {
	WebComponent,
} from 'fg-frontend';
import tippy from 'tippy.js';

export default class Tooltip extends WebComponent {
	didMount() {
		tippy(this.element, {
			arrow: true,
			theme: 'esp',
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/Tooltip.js